import { CORES } from "./coresConcilia";
import { ModoTema } from "./modoTema";

export const PALETA_CLARA = {
  azul: CORES.principal2,
  navy: CORES.principal1,
  icone: CORES.principal1,
  iconeDesabilitado: "#D6E4F7",
  azulFundo: CORES.principal2,
  navyFundo: CORES.principal1,
  fundoPagina: "#FAFAFA",
  borda: "#D6E4F7",
  suave: "#5C6B94",
  fundoSuave: "#F3F8FE",
  fundoCartao: "#FFFFFF",
  textoSobreCor: "#FFFFFF",
  textoTabela: "#636F94",
  cinzaBotao: "#6B7392",
  abaInativa: "#546FA0",
  bordaAba: "#C9D3E6",
  fundoBloco: "#E3EAFA",
  fundoDestaque: "#EDF3FE",
  bordaDestaque: "#2E6BE6",
  verdeTexto: "#1E7A48",
  verdeFundo: "#D9F2E4",
  vermelhoTexto: "#B32544",
  vermelhoFundo: "#FBDDE5",
  ambarTexto: "#8A5B10",
  ambarFundo: "#FCEFD4",
  etiquetaVerdeTexto: "#00723D",
  etiquetaVerdeFundo: "#9AEAC5",
  etiquetaVermelhoTexto: "#B50000",
  etiquetaVermelhoFundo: "#EA9A9A",
  etiquetaAmareloTexto: "#D28100",
  etiquetaAmareloFundo: "#FFE1A8",
  alertaFundo: "#FCE8E8",
  alertaBorda: "#E3A1A1",
  etiquetaCinzaTexto: "#4B4B4C",
  etiquetaCinzaFundo: "#CDCDCD",
  etiquetaArdosiaTexto: "#334159",
  etiquetaArdosiaFundo: "#92ACD9",
  erroTexto: "#D32F52",
  erroFundo: "#FDECEF",
  erroBorda: "#F3C4CE",
  erroCampo: "#D32F2F",
  fundoPainel: "#D7E7FA",
  fundoMenuLateral: "#21277B",
  azulClaroAnterior: "#C2D8F5",
  verdeVariacao: "#1C9B57",
  vermelhoVariacao: "#E0323C",
  textoSobreVariacao: "#FFFFFF",
  amareloParticipacao: "#F5A400",
  trilhoParticipacao: "#E3ECF9",
  gradeGrafico: "#E6EDF8",
  fundoRegistroPay: "#5F83B1",
  seloRegistroPay: "#006AD7",
};

export type NomeCor = keyof typeof PALETA_CLARA;
export type Paleta = Record<NomeCor, string>;

export const PALETA_ESCURA: Paleta = {
  azul: "#7EB3FF",
  navy: "#E8EAED",
  icone: "#7EB3FF",
  iconeDesabilitado: "#565C66",
  azulFundo: "#2F6FE0",
  navyFundo: "#2F6FE0",
  fundoPagina: "#121417",
  borda: "#2C313A",
  suave: "#A0A6B0",
  fundoSuave: "#16191D",
  fundoCartao: "#1E2228",
  textoSobreCor: "#FFFFFF",
  textoTabela: "#B8BDC6",
  cinzaBotao: "#7A808A",
  abaInativa: "#2D4166",
  bordaAba: "#2C313A",
  fundoBloco: "#262B33",
  fundoDestaque: "#1F2A3A",
  bordaDestaque: "#5B9BFF",
  verdeTexto: "#6FD39B",
  verdeFundo: "#1B3328",
  vermelhoTexto: "#FF8DA6",
  vermelhoFundo: "#40222A",
  ambarTexto: "#F2C26B",
  ambarFundo: "#3D311C",
  etiquetaVerdeTexto: "#6FD39B",
  etiquetaVerdeFundo: "#1B3328",
  etiquetaVermelhoTexto: "#FF8DA6",
  etiquetaVermelhoFundo: "#40222A",
  etiquetaAmareloTexto: "#F2C26B",
  etiquetaAmareloFundo: "#3D311C",
  alertaFundo: "#3A2226",
  alertaBorda: "#8C4A55",
  etiquetaCinzaTexto: "#C9C9CB",
  etiquetaCinzaFundo: "#323335",
  etiquetaArdosiaTexto: "#A9BEE3",
  etiquetaArdosiaFundo: "#232B3A",
  erroTexto: "#FF7A93",
  erroFundo: "#40222A",
  erroBorda: "#7A3343",
  erroCampo: "#FF7A93",
  fundoPainel: "#22304A",
  fundoMenuLateral: "#172036",
  azulClaroAnterior: "#3A4A63",
  verdeVariacao: "#3DD68C",
  vermelhoVariacao: "#FF6B73",
  textoSobreVariacao: "#121417",
  amareloParticipacao: "#F5B829",
  trilhoParticipacao: "#262B33",
  gradeGrafico: "#2A2F37",
  fundoRegistroPay: "#2D4166",
  seloRegistroPay: "#006AD7"
};

export const paletaDoModo = (modo: ModoTema): Paleta => (modo === "dark" ? PALETA_ESCURA : PALETA_CLARA);

const nomesCores = Object.keys(PALETA_CLARA) as NomeCor[];

export const variavelCor = (nome: NomeCor) => `--cor-${nome.replace(/[A-Z]/g, (letra) => `-${letra.toLowerCase()}`)}`;

export const cor = (nome: NomeCor) => `var(${variavelCor(nome)}, ${PALETA_CLARA[nome]})`;

export const variaveisCss = (paleta: Paleta) =>
  nomesCores.reduce<Record<string, string>>((variaveis, nome) => ({ ...variaveis, [variavelCor(nome)]: paleta[nome] }), {});

export const aplicarVariaveisCss = (elemento: HTMLElement, paleta: Paleta) =>
  nomesCores.forEach((nome) => elemento.style.setProperty(variavelCor(nome), paleta[nome]));
